(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cibernetica-contact-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cib-contact-dialog')) {
    customElements.define('cib-contact-dialog', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.opener = null;
        const openDialog = (opener) => {
          if (!this.dialog || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
          this.opener = opener?.closest('.cib-mobile-menu')?.querySelector('summary') || opener;
          const topic = this.querySelector('#CibContactTopic');
          if (topic && opener) topic.value = opener.dataset.cibContactTopic || topic.dataset.cibContactDefault;
          const page = this.querySelector('[data-cib-contact-page]');
          if (page && opener?.dataset.cibContactPage) page.value = opener.dataset.cibContactPage;
          document.querySelector('.cib-mobile-menu')?.removeAttribute('open');
          this.dialog.showModal();
          document.documentElement.classList.add('cib-contact-is-open');
          (this.querySelector('[data-cib-contact-result]') || this.querySelector('#CibContactName'))?.focus({ preventScroll: true });
        };
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-cib-contact-open], .cib-product-description a[href^="mailto:contact@ciberneticausa.com?"]');
          if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof this.dialog?.showModal !== 'function') return;
          event.preventDefault();
          openDialog(trigger);
        }, options);
        this.querySelector('[data-cib-contact-close]')?.addEventListener('click', () => this.dialog.close(), options);
        this.dialog?.addEventListener('close', () => {
          document.documentElement.classList.remove('cib-contact-is-open');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        if (this.querySelector('[data-cib-contact-result]')) openDialog(null);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.remove('cib-contact-is-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cibernetica-enterprise-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cib-enterprise-gallery')){
 customElements.define('cib-enterprise-gallery',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
   const buttons=[...this.querySelectorAll('[data-erp-slide]')],dialog=this.querySelector('dialog'),opener=this.querySelector('[data-erp-open]'),main=this.querySelector('[data-erp-main]'),large=this.querySelector('[data-erp-large]'),zoom=this.querySelector('[data-erp-zoom]');let index=0;
   const select=(next)=>{index=(next+buttons.length)%buttons.length;const b=buttons[index],alt=b.dataset.title+'. '+b.dataset.caption+' Fictional example.';buttons.forEach((x,i)=>x.setAttribute('aria-pressed',String(i===index)));main.src=b.dataset.src;main.alt=alt;opener.href=b.dataset.src;opener.setAttribute('aria-label','Expand '+b.dataset.title.toLowerCase()+' sample');large.src=b.dataset.src;large.alt=alt;this.querySelector('[data-erp-caption]').textContent=b.dataset.caption;this.querySelector('[data-erp-title]').textContent=b.dataset.title;this.querySelector('[data-erp-dialog-caption]').textContent=b.dataset.caption;this.querySelector('[data-erp-count]').textContent=(index+1)+' / '+buttons.length;this.querySelector('[data-erp-original]').href=b.dataset.src;dialog.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');zoom.textContent='Zoom image';};
   buttons.forEach((b,i)=>b.addEventListener('click',()=>select(i),options));
   opener.addEventListener('click',(event)=>{if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||typeof dialog.showModal!=='function')return;event.preventDefault();dialog.showModal();document.documentElement.classList.add('cib-erp-open');this.querySelector('[data-erp-close]').focus({preventScroll:true});},options);
   this.querySelector('[data-erp-close]').addEventListener('click',()=>dialog.close(),options);
   this.querySelector('[data-erp-prev]').addEventListener('click',()=>select(index-1),options);this.querySelector('[data-erp-next]').addEventListener('click',()=>select(index+1),options);
   zoom.addEventListener('click',()=>{const active=dialog.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(active));zoom.textContent=active?'Fit image':'Zoom image';},options);
   dialog.addEventListener('keydown',(event)=>{if(event.key==='ArrowRight'){event.preventDefault();select(index+1);}if(event.key==='ArrowLeft'){event.preventDefault();select(index-1);}},options);
   dialog.addEventListener('close',()=>{document.documentElement.classList.remove('cib-erp-open');opener.focus({preventScroll:true});},options);
   select(0);
  }
  disconnectedCallback(){this.querySelector('dialog')?.close();this.controller?.abort();document.documentElement.classList.remove('cib-erp-open');}
 });}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cibernetica-preview-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cib-preview-gallery')) {
    customElements.define('cib-preview-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        const closeButton = this.querySelector('[data-preview-close]');
        const loading = this.querySelector('[data-preview-loading]');
        const error = this.querySelector('[data-preview-error]');
        this.querySelectorAll('[data-preview-trigger]').forEach((trigger) => {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', this.dialog.id);
          trigger.addEventListener('keydown', (event) => {
            if (event.key === ' ') {
              event.preventDefault();
              trigger.click();
            }
          }, { signal });
          trigger.addEventListener('click', (event) => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.opener = trigger;
            const thumbnail = trigger.querySelector('img');
            const image = thumbnail.cloneNode(false);
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.removeAttribute('id');
            image.className = 'cib-preview-dialog-image';
            image.loading = 'eager';
            image.alt = thumbnail.alt || trigger.closest('figure').querySelector('figcaption').textContent;
            loading.hidden = false;
            error.hidden = true;
            image.addEventListener('load', () => { loading.hidden = true; }, { once: true, signal });
            image.addEventListener('error', () => {
              loading.hidden = true;
              error.hidden = false;
              image.hidden = true;
            }, { once: true, signal });
            image.src = trigger.href;
            this.querySelector('[data-preview-image]').replaceChildren(image);
            this.querySelector('[data-preview-caption]').textContent = image.alt;
            this.dialog.showModal();
            document.documentElement.classList.add('cib-preview-is-open');
            closeButton.focus({ preventScroll: true });
          }, { signal });
        });
        closeButton.addEventListener('click', () => this.dialog.close(), { signal });
        const isOutside = (event) => {
          const rect = this.dialog.getBoundingClientRect();
          return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
        };
        this.dialog.addEventListener('pointerdown', (event) => { this.startedOutside = isOutside(event); }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (this.startedOutside && isOutside(event)) this.dialog.close();
          this.startedOutside = false;
        }, { signal });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('cib-preview-is-open');
          this.opener?.focus({ preventScroll: true });
        }, { signal });
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.classList.remove('cib-preview-is-open');
        }
        this.abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cibernetica-service-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cib-service-gallery')){
 customElements.define('cib-service-gallery',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
   const buttons=[...this.querySelectorAll('[data-svc-slide]')],dialog=this.querySelector('dialog'),opener=this.querySelector('[data-svc-open]'),main=this.querySelector('[data-svc-main]'),large=this.querySelector('[data-svc-large]'),zoom=this.querySelector('[data-svc-zoom]');let index=0;
   const select=(next)=>{index=(next+buttons.length)%buttons.length;const b=buttons[index],alt=b.dataset.title+'. '+b.dataset.caption+' Fictional example.';buttons.forEach((x,i)=>x.setAttribute('aria-pressed',String(i===index)));main.src=b.dataset.src;main.alt=alt;opener.href=b.dataset.src;opener.setAttribute('aria-label','Expand '+b.dataset.title.toLowerCase()+' sample');large.src=b.dataset.src;large.alt=alt;this.querySelector('[data-svc-caption]').textContent=b.dataset.caption;this.querySelector('[data-svc-title]').textContent=b.dataset.title;this.querySelector('[data-svc-dialog-caption]').textContent=b.dataset.caption;this.querySelector('[data-svc-count]').textContent=(index+1)+' / '+buttons.length;this.querySelector('[data-svc-original]').href=b.dataset.src;dialog.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');zoom.textContent='Zoom image';};
   buttons.forEach((b,i)=>b.addEventListener('click',()=>select(i),options));
   opener.addEventListener('click',(event)=>{if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||typeof dialog.showModal!=='function')return;event.preventDefault();dialog.showModal();document.documentElement.classList.add('cib-svc-open');this.querySelector('[data-svc-close]').focus({preventScroll:true});},options);
   this.querySelector('[data-svc-close]').addEventListener('click',()=>dialog.close(),options);
   this.querySelector('[data-svc-prev]').addEventListener('click',()=>select(index-1),options);this.querySelector('[data-svc-next]').addEventListener('click',()=>select(index+1),options);
   zoom.addEventListener('click',()=>{const active=dialog.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(active));zoom.textContent=active?'Fit image':'Zoom image';},options);
   dialog.addEventListener('keydown',(event)=>{if(event.key==='ArrowRight'){event.preventDefault();select(index+1);}if(event.key==='ArrowLeft'){event.preventDefault();select(index-1);}},options);
   dialog.addEventListener('close',()=>{document.documentElement.classList.remove('cib-svc-open');opener.focus({preventScroll:true});},options);
   select(0);
  }
  disconnectedCallback(){this.querySelector('dialog')?.close();this.controller?.abort();document.documentElement.classList.remove('cib-svc-open');}
 });}
  } catch(e) { console.error(e); }
})();

})();
